import { useTranslations } from '@vocab/react';
import {
  Box,
  Column,
  Columns,
  Inline,
  Text,
  Loader,
} from 'braid-design-system';
import React from 'react';

import { useAnalyticsContext } from '../../../../modules/analytics/AnalyticsContext';
import { useAppContext } from '../../../AppContext';
import { DefaultLinkRenderer, type LinkRendererType } from '../LinkRenderer';

import translations from './.vocab';
import { getLinks } from './links';

interface Props {
  linkRenderer?: LinkRendererType;
}

const Footer = ({
  linkRenderer: LinkRenderer = DefaultLinkRenderer,
}: Props) => {
  const { t } = useTranslations(translations);
  const { site, siteNameOnFooter, isStaticRender, getClientHref } =
    useAppContext();
  const {
    analytics: { trackLink },
  } = useAnalyticsContext();

  return (
    <Box
      component="footer"
      background="surface"
      padding={{ mobile: 'medium', tablet: 'gutter', desktop: 'gutter' }}
    >
      <Columns space={['large', 'gutter']} collapseBelow="tablet">
        <Column>
          <Inline space="large" collapseBelow="tablet">
            {isStaticRender ? (
              <Loader size="small" />
            ) : (
              getLinks(site).map(
                ({
                  name,
                  analytics: eventName,
                  linkText,
                  href,
                  rel,
                  experience,
                }) => (
                  <LinkRenderer
                    key={name}
                    href={getClientHref(href, experience)}
                    rel={rel}
                    data-analytics={eventName}
                    onClick={() =>
                      trackLink({
                        eventName,
                        linkPosition: 'footer',
                        isThirdPartyLink: 'false',
                        linkText,
                      })
                    }
                  >
                    {t(name)}
                  </LinkRenderer>
                ),
              )
            )}
          </Inline>
        </Column>
        <Column width="content">
          <Text size="small" tone="secondary">
            {t('\u00A9Seek. All rights reserved.', {
              siteNameOnFooter,
            })}
          </Text>
        </Column>
      </Columns>
    </Box>
  );
};

export default Footer;
